import { TeliaCol, TeliaRow, TeliaTextSpacing } from '@teliads/components/react';
import { forwardRef, ReactNode, useEffect } from 'react';

import { useHeader } from '../Navigation/contexts/Header.context';

import Heading from 'components/voca/heading/Heading';
import subscribeToResize from 'utils/resize';

import 'components/custom/content-block/ContentBlock.scss';

interface Props {
  id: string;
  title: string;
  content: ReactNode;
  onResize: (p: any) => void;
}

export const ContentBlock = forwardRef<HTMLDivElement, Props>(
  ({ id, title, content, onResize }, ref) => {
    const { headerHeight } = useHeader();

    useEffect(() => {
      return subscribeToResize(ref, onResize);
    }, [onResize, ref]);

    return (
      <div
        ref={ref}
        id={id}
        className="content-block"
        style={{ '--header-height': `${headerHeight}px` } as StringsDictionary}
        data-testid="content-block"
      >
        <TeliaRow>
          <TeliaCol width={12} widthLg={3}>
            <Heading variant="title-300" tag="h2" className="content-block__title">
              {title}
            </Heading>
          </TeliaCol>

          <TeliaCol width={12} widthLg={1} />

          <TeliaCol width={12} widthLg={8}>
            <TeliaTextSpacing>
              <div className="content-block__content">{content}</div>
            </TeliaTextSpacing>
          </TeliaCol>
        </TeliaRow>
      </div>
    );
  }
);
